webpackJsonp([36333245135106],{

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _api = __webpack_require__(45);
	
	var _loader = __webpack_require__(44);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _Card = __webpack_require__(43);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cardEntry = (0, _styledComponents.keyframes)(['to{transform:translateY(0);opacity:1;}']);
	
	var DivGrid = _styledComponents2.default.div.withConfig({
	  displayName: 'publicsector__DivGrid'
	})(['display:grid;grid-gap:32px;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));grid-template-rows:auto;}']);
	
	var StyledArticle = _styledComponents2.default.article.withConfig({
	  displayName: 'publicsector__StyledArticle'
	})(['padding:0;margin:0;animation:', ' .8s ease 1;animation-delay:0.', 's;animation-fill-mode:forwards;transform:translateY(80px);opacity:0;height:100%;min-height:300px;'], cardEntry, function (props) {
	  return props.delay;
	});
	
	var PublicSector = function (_React$Component) {
	  _inherits(PublicSector, _React$Component);
	
	  function PublicSector(props) {
	    _classCallCheck(this, PublicSector);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      posts: []
	    };
	    return _this;
	  }
	
	  PublicSector.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    (0, _api.fetchPublicSectorData)(function (posts) {
	      _this2.setState({
	        posts: posts
	      });
	    });
	  };
	
	  PublicSector.prototype.render = function render() {
	    if (this.state.posts.length === 0) {
	      return _react2.default.createElement(_loader2.default, null);
	    }
	
	    var renderPosts = this.state.posts.map(function (post, i) {
	      return _react2.default.createElement(
	        StyledArticle,
	        { key: i, delay: i },
	        _react2.default.createElement(_Card2.default, post)
	      );
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: 'pageTitle' },
	        'PUBLIC SECTOR'
	      ),
	      _react2.default.createElement(
	        DivGrid,
	        null,
	        renderPosts
	      )
	    );
	  };
	
	  return PublicSector;
	}(_react2.default.Component);
	
	exports.default = PublicSector;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-publicsector-js-9a9950a1e082a974d9c3.js